import type { StatusTone } from '@/components/StatusPill/StatusPill';
import type { Invoice } from '@/store/expenses-store/invoices/invoices.dto';

const IN_TRANSIT_STATUSES = ['waits_for_receiving'];

const humanizeStatus = (status: string): string =>
  status
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');

export const isInvoicePaid = (invoice: Invoice) => invoice.status === 'processed';

export const isInvoiceInTransit = (invoice: Invoice) =>
  IN_TRANSIT_STATUSES.includes(invoice.status);

export const isInvoiceOverdue = (invoice: Invoice) => {
  if (isInvoicePaid(invoice)) return false;
  const due = invoice.detail?.dueDate as string | undefined;
  if (!due) return false;
  const dueDate = new Date(due);
  return !Number.isNaN(dueDate.getTime()) && dueDate < new Date();
};

export const invoiceStatusLabel = (invoice: Invoice): string => {
  if (isInvoicePaid(invoice)) return 'Paid';
  if (invoice.status === 'declined') return 'Declined';
  if (isInvoiceInTransit(invoice)) return 'In Transit';
  if (isInvoiceOverdue(invoice)) return 'Overdue';
  return 'Unpaid';
};

export const invoiceStatusTone = (invoice: Invoice): StatusTone => {
  if (isInvoicePaid(invoice)) return 'success';
  if (invoice.status === 'declined') return 'danger';
  if (isInvoiceInTransit(invoice)) return 'progress';
  if (isInvoiceOverdue(invoice)) return 'danger';
  return 'warning';
};

export const invoiceRawStatusLabel = (invoice: Invoice): string =>
  isInvoiceInTransit(invoice) ? 'In Transit' : humanizeStatus(invoice.status);
